import type {
    ControllerProviderType } from "@rosette/royalur_react/src/game/createControllerContext.js";
import {
    createControllerContext,
    useCreateController,
} from "@rosette/royalur_react/src/game/createControllerContext.js";
import { PlayerStateController } from "@rosette/ts/src/business/game/controller/playerstate/PlayerStateController.js";
import type { PlayerStateDirective } from "@rosette/ts/src/business/game/controller/playerstate/PlayerStateDirective.js";


function createPlayerStateControllerContext(): {
    PlayerStateControllerProvider: ControllerProviderType;
    usePlayerStateController: () => PlayerStateController;
    usePlayerStateDirective: () => PlayerStateDirective;
    usePlayerStateDirectiveSelector: <V>(selector: (directive: PlayerStateDirective) => V) => V;
} {
    const useCreatePlayerStateController = () => {
        return useCreateController<PlayerStateDirective, PlayerStateController>(
            () => new PlayerStateController(), [],
        );
    };
    const {
        ControllerProvider, useController, useDirective, useDirectiveSelector,
    } = createControllerContext<PlayerStateDirective, PlayerStateController>(useCreatePlayerStateController);

    return {
        PlayerStateControllerProvider: ControllerProvider,
        usePlayerStateController: useController,
        usePlayerStateDirective: useDirective,
        usePlayerStateDirectiveSelector: useDirectiveSelector,
    };
}

export const {
    PlayerStateControllerProvider,
    usePlayerStateController,
    usePlayerStateDirective,
} = createPlayerStateControllerContext();
